import React, { Fragment, useEffect, useState } from "react";

import { Col, Flex, Row } from "antd";

import CardComponent from "@/components/card";

import "@/styles/components/plans.scss";
import IconTick from "@/components/icons/IconTick";
import ButtonComponent from "@/components/button/Button";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import orderBy from "lodash/orderBy";
import {
  setCheckoutType,
  setIsCheckoutToShow,
  setIsProductRegisterSuccessToShow,
  setProductData,
  setRegisteProductId,
} from "@/reducers/checkoutSlice";
import { getProductData } from "@/services/common/getProductData";
import {
  getIsLoggedIn,
  getUserInfo,
  setCurrentForm,
  setFormProps,
  setModalOpen,
} from "@/reducers/commonSlice";
import { getProducts } from "@/services/services/getProducts";
import IconVector2 from "@/components/icons/IconVector2";
import { registerProducts } from "@/services/services/registerProducts";

const Plans = ({ stage = "all" }) => {
  const [planData, setPlanData] = useState([]);
  // const [selectedPlan, setSelectedPlan] = useState("all");
  const [activeStage, setActiveStage] = useState("all");

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isLoggedIn = useSelector(getIsLoggedIn);
  const userInfo = useSelector(getUserInfo);

  useEffect(() => {
    fetchStageData();
  }, [stage, userInfo]);

  const plans = [
    {
      label: "All",
      value: "all",
    },
    {
      label: "Planning to apply abroad",
      value: "PreApplication",
    },
    {
      label: "Already Applied Abroad",
      value: "AlreadyApplied",
    },
    {
      label: "Ready To Fly Abroad",
      value: "GotAdmission",
    },
    {
      label: "Already at University Abroad",
      value: "AlreadyAtUniversity",
    },
  ];

  const handleChipClick = (value) => {
    setActiveStage(value);
    if (value === "all") {
      fetchPlan("all");
    } else {
      const fetchProductData = isLoggedIn ? getProducts : getProductData;
      if (value === "PreApplication") {
        fetchProductData("PreApplication")
          .then((response) => {
            setPlanData(orderBy(response, ["highlighted"], [true]).reverse().slice(0, 3));
          })
          .catch((error) => console.log(error));
      } else if (value === "AlreadyApplied") {
        fetchProductData("AlreadyApplied")
          .then((response) => {
            setPlanData(orderBy(response, ["highlighted"], [true]).reverse().slice(0, 3));
          })
          .catch((error) => console.log(error));
      } else if (value === "GotAdmission") {
        fetchProductData("GotAdmission")
          .then((response) => {
            setPlanData(orderBy(response, ["highlighted"], [true]).reverse().slice(0, 3));
          })
          .catch((error) => console.log(error));
      } else if (value === "AlreadyAtUniversity") {
        fetchProductData("AlreadyAtUniversity")
          .then((response) => {
            setPlanData(orderBy(response, ["highlighted"], [true]).reverse().slice(0, 3));
          })
          .catch((error) => console.log(error));
      }
    }
  };

  const fetchStageData = () => {
    let stage = null;

    if (!isLoggedIn) {
      stage = localStorage.getItem("stage");
    } else {
      stage = userInfo?.stage
        ?.toLowerCase()
        .split(" ")
        .map((x) => x.charAt(0).toUpperCase() + x.slice(1))
        .join(""); // Return type "PreApplication" || "AlreadyApplied" || "GotAdmission" || "AlreadyAtUniversity"
    }

    const stageMapping = {
      "Pre application": "PreApplication",
      "Already applied": "AlreadyApplied",
      "Got admission": "GotAdmission",
      "Already at university": "AlreadyAtUniversity",
    };

    // console.log(stage);
    setActiveStage(stage ?? stageMapping[userInfo?.stage] ?? "PreApplication");
  };

  const handleAddToCart = (data) => {
    console.log(data);
    if (isLoggedIn) {
      if (data.action === "Register") {
        registerProducts({
          productId: data.id,
        })
          .then((res) => {
            dispatch(setCurrentForm("productSuccess"));
            dispatch(setModalOpen(true));
            dispatch(
              setFormProps({
                message: "Your interest was registered",
                subMessage: "Team will contact you shortly",
                onSubmit: () => {
                  dispatch(setModalOpen(false));
                  dispatch(setIsProductRegisterSuccessToShow(false));
                },
              })
            );
          })
          .catch((err) => console.log(err));
      } else {
        dispatch(setCheckoutType(true));
        dispatch(setProductData(data));
        navigate("/checkout-preview");
      }
    } else {
      if (data.action === "Register") {
        dispatch(setIsProductRegisterSuccessToShow(true));
        dispatch(setRegisteProductId(data.id));
      } else {
        dispatch(setCheckoutType(true));
        dispatch(setIsCheckoutToShow(true));
        dispatch(setProductData(data));
      }
      dispatch(setModalOpen(true));
      dispatch(setCurrentForm("signIn"));
    }
  };

  const fetchPlan = async (filteredStage) => {
    if (isLoggedIn) {
      getProducts(activeStage !== "all" ? activeStage : "")
        .then((response) => {
          // fetchStageData();
          const cloneData = response?.filter((x) => x.stage !== "Membership");
          setPlanData(orderBy(cloneData, ["highlighted"], [true]).reverse().slice(0, 3));
        })
        .catch((error) => console.log(error));
    } else {
      getProductData(filteredStage !== "all" ? filteredStage : "")
        .then((response) => {
          const cloneData = response?.filter((x) => x.stage !== "Membership");
          const tempData = orderBy(cloneData, ["highlighted"], [true]).reverse().slice(0, 3);
          setPlanData(tempData);
        })
        .catch((error) => console.log(error));
    }
  };

  useEffect(() => {
    fetchPlan(activeStage);
  }, [isLoggedIn, activeStage, stage]);

  return (
    <Fragment>
      <div className="plans-container">
        <div className="offering">
          <div className="title-h5-1">Offerings:</div>
          <div className="body-h2">
            Where are you in your study abroad journey? Choose the tab below of view our top
            offerings or view all.
          </div>
          <div className="d-flex flex-wrap services">
            <div className="chip-container d-flex flex-wrap">
              {plans.map((plan) => (
                <div
                  key={plan.value}
                  className={`chip ${activeStage === plan.value ? "chip-selected" : ""}`}
                  onClick={() => handleChipClick(plan.value)}
                >
                  {plan.label}
                </div>
              ))}
            </div>
            <div className="view-services" onClick={() => navigate("/plans")}>
              <label style={{ cursor: "pointer" }}>View all services</label>
              <IconVector2 />
            </div>
          </div>
        </div>
        <Row gutter={[22, 22]}>
          {planData?.map((data, index) => (
            <Fragment key={index + 1}>
              <Col xs={24} sm={12} md={12} lg={8} xl={8} xxl={8}>
                <div
                  className={data.highlighted ? "highlighted plan-card h-100" : "plan-card h-100"}
                >
                  <CardComponent className="card-wrapper h-100">
                    <Row style={{ height: "100%" }} justify="space-between" align="stretch">
                      <Col span={24}>
                        <div className="plan-heading title-h5-1">{data.title}</div>
                        {data.discount ? (
                          <div className="discount-chip body-b4">Save {data.discount} %</div>
                        ) : null}
                        <div className="plan-sub-heading body-b2">{data.stage}</div>
                        {data.offerings.map((item, i) => {
                          return (
                            <Flex key={i} className="including body-b4" gap="10px" align="center">
                              <IconTick />
                              <span style={{ width: "80%" }}>{item}</span>
                            </Flex>
                          );
                        })}
                      </Col>
                      <Col span={24} style={{ marginTop: "auto" }}>
                        {data.price ? <div className="price title-h5-1">£ {data.price}</div> : null}
                        <div className="button">
                          <ButtonComponent
                            label={
                              data.action !== "Register" ? "Buy now" : "Register your Interest"
                            }
                            varient="primary"
                            onClick={() => handleAddToCart(data)}
                            disabled={!!data.isPurchased || !!data.isRegistered}
                          />
                        </div>
                      </Col>
                    </Row>
                  </CardComponent>
                </div>
              </Col>
            </Fragment>
          ))}
        </Row>
      </div>
    </Fragment>
  );
};

export default Plans;
